import {
  Component,
  Input,
  forwardRef,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output
} from '@angular/core'

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms'

import {
  Dimension,
  Metric
} from '../../../../models/analytics-api/schema.model';
import { TrackingService } from '@hub-components';

export const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PropertiesListComponent),
  multi: true,
}

@Component({
  selector: 'properties-list',
  styleUrls: ['properties-list.component.less'],
  templateUrl: 'properties-list.component.html',
  providers: [
    VALUE_ACCESSOR
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertiesListComponent implements ControlValueAccessor, OnInit {
  @Input() ngModel: any
  @Input() options: Dimension[]
  @Input() editableOptions: any[]
  @Input() visibleOptions: any[]
  @Input() canOrderResult: boolean
  @Input() orderState: any
  @Output() orderBy = new EventEmitter()

  onChange: Function | null
  public descriptionVisible: boolean = false;
  public property: { name: string, description: string };
  public propertySelectionStates: { [key: string]: boolean } = {};

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private trackingService: TrackingService,
  ) {}

  ngOnInit() {
    this.updatePropertySelectionStates();
  }

  private updatePropertySelectionStates() {
    this.propertySelectionStates = {};
    if (this.ngModel) {
      this.options.forEach(dimension => {
        if (this.ngModel[dimension.name]) {
          this.ngModel[dimension.name].forEach(propertyName => {
            const key = this.getPropertyKey(dimension, propertyName);
            this.propertySelectionStates[key] = true;
          });
        }
      });
    }
  }

  private getPropertyKey(dimension: Dimension, propertyName: string): string {
    return `${dimension.name}.${propertyName}`;
  }

  public showDescription(property) {
    this.descriptionVisible = true;
    this.property = { name: property.displayName, description: property.meta.display.description };
  }

  isSelected(dimension, property) {
    return this.ngModel && this.ngModel[dimension.name] && this.ngModel[dimension.name].includes(property.name)
  }

  toggleItem(isSelected, dimension, property) {
    const result = Object.clone(this.ngModel, true)
    const properties = (result[dimension.name] || (result[dimension.name] = []))
    const propertyKey = this.getPropertyKey(dimension, property.name);
    if (isSelected) {
      properties.push(property.name)
      properties.sortBy(name => dimension.properties.findIndex(prop => prop.name === name))
      this.propertySelectionStates[propertyKey] = true;
    } else {
      properties.remove(property.name)
      this.propertySelectionStates[propertyKey] = false;
    }

    if (this.onChange) {
      this.onChange(result)
    }
    this.changeDetectorRef.markForCheck();
  }

  onOrderBy(event, dimension, property) {
    const name = `${dimension.name}.${property.name}`
    this.trackingService.track('Sort by dimensionProperty', { value: { name } });
    this.orderBy.emit({ event: event, name, type: 'dimensionProperty' })
  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.ngModel = value
      this.updatePropertySelectionStates();
      this.changeDetectorRef.markForCheck()
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn
  }

  registerOnTouched(fn: any) { }
}
